module.exports = __webpack_public_path__ + "img/3-8.2ae097c1.png";